import React from 'react';

import FormBase from '../FormBase';

import Text from '../../../../components/Typography/Text';
import { useAccountContext } from '../Data/accountContext';
import { isDisabledJumio } from '../../../../lib/data/common';
import FormIdentificationJumio from '../Common/FormIdentificationJumio';
import FormIdentificationInput from '../Common/FormIdentificationInput';
import { hasError, validateIdentification } from '../Data/validation';
import { saveRegistrationIdentification } from '../../../../services/RegistrationService';

export default function FormIdentification() {
  const { account, setAccountResponse, disableUpdate } = useAccountContext();
  const [validation, setValidation] = React.useState({
    primaryOwner: {},
    corpOwnersList: [],
  });

  const addDefaultAddress = (country, owner) => {
    if (owner.isSameTaxCountry) {
      owner.taxCountry = country;
    }

    if (owner.isSameCitizenship) {
      owner.citizenship = country;
    }

    if (owner.isSameCountryOfIssuance) {
      owner.countryOfIssuance = country;
    }

    return owner;
  };

  const handleSave = async () => {
    let primaryOwner = { ...account.primaryOwner.identification };

    primaryOwner = addDefaultAddress(
      account.primaryOwner.country,
      primaryOwner
    );

    let primarErrs = validateIdentification(primaryOwner, account.primaryOwner);
    const copyValidation = { primaryOwner: primarErrs, corpOwnersList: [] };

    let corpOwnersList = [];

    for (let index = 0; index < account?.corpOwnersList?.length || 0; index++) {
      const coOwner = addDefaultAddress(
        account.corpOwnersList[index].country,
        account.corpOwnersList[index].identification
      );

      let errs = {};

      if (
        account.corpOwnersList[index].isOwner &&
        account.corpOwnersList[index].ownershipPercent >= 25
      ) {
        errs = validateIdentification(
          account.corpOwnersList[index].identification,
          account.corpOwnersList[index]
        );
      }
      copyValidation.corpOwnersList.push(errs);

      corpOwnersList.push(coOwner);
    }

    setValidation(copyValidation);

    if (hasError(copyValidation)) {
      console.log('identification errs', copyValidation);
      return { acct: account, err: true };
    }

    let request = {
      primaryOwner,
      corpOwnersList,
    };

    if (isDisabledJumio) {
      request.kycStatus = 'Approved';
    }

    const res = await saveRegistrationIdentification(request);
    setAccountResponse(res);

    return { acct: res, err: false };
  };

  return (
    <FormBase
      name="identification"
      header="Proof of Identity"
      subHeader=""
      faq="Identification"
      save={handleSave}
    >
      <form className="identity-form-w" autoComplete="off">
        <input type="hidden" autoComplete="off" />

        {!['Approved', 'Warning'].includes(account.primaryOwner.identification?.kycStatus)&&
          !isDisabledJumio ? (
          <FormIdentificationJumio />
        ) : (
          <FormIdentificationInput objectName="primaryOwner" validation={validation} />
        )}
      </form>

      {account?.corpOwnersList?.map((_, index) => {
        const owner = account.corpOwnersList[index];
        if (owner.ownershipPercent < 25 || !owner.isOwner) {
          return <React.Fragment key={index} />;
        }

        let ownerName = (owner?.firstName || '') + ' ' + (owner?.lastName || '');
        return (
          <div className="mt-50" key={index}>
            <Text
              mb={25}
              variant="h2"
              error={!!validation.corpOwnersList[index]?.ownerId}
              label={'Co-Owner: ' + ownerName}
            />
            <Text
              mb={25}
              variant="body1"
              error={!!validation.corpOwnersList[index]?.ownerId}
              label={validation.corpOwnersList[index]?.ownerId}
            />
            <FormIdentificationInput
              objectName="corpOwnersList"
              validation={validation}
              index={index}
            />
          </div>
        );
      })}
    </FormBase>
  );
}
